import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row, Label, Input, FormFeedback } from "reactstrap";
import { toast } from "react-toastify";

const Campo = ({ label, valor }) =>
  valor ? (
    <div className="mb-2">
      <span className="text-muted small">{label}: </span>
      <span className="fw-medium">{valor}</span>
    </div>
  ) : null;

const PasoConfirmacion = ({
  datos,
  listaFarmacias,
  actualizarDatos,
  onAnterior,
  onEnviar,
  enviando,
}) => {
  const [errores, setErrores] = useState({});

  // Establecer valor predeterminado de Mérida si no hay farmacia asignada
  useEffect(() => {
    if (!datos.farmaciaAsignada && listaFarmacias.length > 0) {
      // Buscar farmacia que contenga "Mérida" o "Merida"
      const farmaciaMerida = listaFarmacias.find(f => 
        f.label.toLowerCase().includes('mérida') || 
        f.label.toLowerCase().includes('merida')
      );
      
      if (farmaciaMerida) {
        actualizarDatos({ farmaciaAsignada: farmaciaMerida.value });
      } else {
        // Si no encuentra Mérida, usar la primera farmacia como fallback
        actualizarDatos({ farmaciaAsignada: listaFarmacias[0].value });
      }
    }
  }, [datos.farmaciaAsignada, listaFarmacias, actualizarDatos]);

  const validar = () => {
    const nuevosErrores = {};
    
    if (!datos.farmaciaAsignada || datos.farmaciaAsignada.trim() === "") {
      nuevosErrores.farmaciaAsignada = "Debe seleccionar una farmacia responsable";
    }
    
    setErrores(nuevosErrores);
    
    if (Object.keys(nuevosErrores).length > 0) {
      toast.warning("Por favor seleccione una farmacia responsable");
      return false;
    }
    
    return true;
  };

  const handleEnviar = () => {
    if (validar()) {
      onEnviar();
    }
  };
  return (
    <Card>
      <CardHeader>
        <h5 className="mb-0">
          <i className="ri-check-double-line me-2 text-primary"></i>
          Paso 4 — Asignación y Confirmación
        </h5>
      </CardHeader>
      <CardBody>
        {/* Farmacia */}
        <div className="mb-4">
          <h6 className="text-primary mb-3">Farmacia Responsable</h6>
          <Row>
            <Col md={6}>
              <Label className="form-label">
                Farmacia asignada <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                value={datos.farmaciaAsignada}
                onChange={(e) => actualizarDatos({ farmaciaAsignada: e.target.value })}
                invalid={!!errores.farmaciaAsignada}
              >
                <option value="">Seleccione una farmacia...</option>
                {listaFarmacias.map((f) => (
                  <option key={f.value} value={f.value}>
                    {f.label}
                  </option>
                ))}
              </Input>
              <FormFeedback>{errores.farmaciaAsignada}</FormFeedback>
            </Col>
          </Row>
        </div>

        {/* Resumen */}
        <hr />
        <h6 className="text-primary mb-3">Resumen de la Solicitud</h6>

        <div className="border rounded p-3 bg-light mb-3">
          <Row>
            <Col md={6}>
              <p className="text-muted small mb-2 fw-semibold">DATOS DEL PACIENTE</p>
              <Campo label="ID Solicitud Mercantil" valor={datos.identificador} />
              <Campo label="Titular" valor={datos.titular} />
              <Campo label="Cédula Titular" valor={datos.titularCedula} />
              <Campo label="Solicitante" valor={datos.solicitante} />
              <Campo label="Cédula Solicitante" valor={datos.solicitanteCedula} />
              <Campo label="Teléfono" valor={datos.telefono} />
              <Campo label="Correo" valor={datos.correoElectronico} />
              <Campo label="Recibe" valor={datos.recibe} />
            </Col>
            <Col md={6}>
              <p className="text-muted small mb-2 fw-semibold">DATOS MÉDICOS</p>
              <Campo label="Tipo" valor={datos.tipo} />
              <Campo label="Diagnóstico" valor={datos.diagnostico} />
              <Campo label="Detalle" valor={datos.detalle} />
              <Campo label="Informe" valor={datos.informe ? "Archivo cargado" : null} />
              <Campo label="Recipe" valor={datos.recipe ? "Archivo cargado" : null} />
              <Campo label="Observaciones" valor={datos.observaciones} />
              <Campo
                label="Medicamentos"
                valor={datos.capturaMedicamentos ? "Captura cargada" : null}
              />
            </Col>
          </Row>
        </div>

        <div className="alert alert-info d-flex align-items-center gap-2">
          <i className="ri-information-line fs-5"></i>
          <div>
            Esta solicitud será creada con <strong>aseguradora = Seguros Mercantil</strong> y no
            enviará ninguna notificación a SISCOTEL. Los archivos se subirán después de crear la solicitud.
          </div>
        </div>

        <div className="d-flex justify-content-between mt-4">
          <button className="btn btn-light" onClick={onAnterior} disabled={enviando}>
            <i className="ri-arrow-left-line me-1"></i> Anterior
          </button>
          <button
            className="btn btn-success"
            onClick={handleEnviar}
            disabled={enviando}
          >
            {enviando ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status" />
                Creando solicitud...
              </>
            ) : (
              <>
                <i className="ri-send-plane-line me-1"></i> Crear Solicitud
              </>
            )}
          </button>
        </div>
      </CardBody>
    </Card>
  );
};

export default PasoConfirmacion;
